import {
  IconBolt as Zap,
  IconClipboardCheck as ClipboardCheck,
  IconEye as Eye,
  IconFileCheck as FileCheck,
} from "@tabler/icons-react";

export function SolutionSection({ t }) {
  const icons = [Zap, Eye, FileCheck, ClipboardCheck];

  return (
    <section id="solution" className="relative py-24 md:py-32 overflow-hidden">
      <div
        className="orb"
        style={{ width: 480, height: 480, background: "hsl(var(--brand) / 0.3)", top: 60, left: -120 }}
      />

      <div className="container-x relative">
        <div className="grid gap-12 lg:grid-cols-12 lg:items-center">
          <div className="reveal lg:col-span-7">
            <div className="eyebrow mb-4 inline-flex">{t.solution.eyebrow}</div>
            <h2 className="font-display text-[clamp(2rem,4.2vw,3.5rem)] leading-[1.25] font-medium">
              {t.solution.title.split("innospeq").map((part, i, arr) => (
                <span key={i}>
                  {part}
                  {i < arr.length - 1 && <span className="text-brand">innospeq</span>}
                </span>
              ))}
            </h2>
            <p className="mt-6 text-lg text-muted-foreground max-w-xl leading-relaxed">
              <InlineBold text={t.solution.lead} />
            </p>
          </div>

          <div className="reveal lg:col-span-5 flex justify-center">
            <PhoneVideo />
          </div>
        </div>

        <div className="reveal mt-16 mx-auto max-w-md text-center">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">
            {t.solution.result}
          </span>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {t.solution.points.map((p, i) => {
            const Icon = icons[i];
            return (
              <div
                key={i}
                className="reveal group relative overflow-hidden rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--surface))] p-6 transition-all hover:-translate-y-1 hover:border-brand"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand text-white">
                  <Icon className="h-5 w-5" />
                </div>
                <div className="font-display text-xl font-semibold">{p.title}</div>
                <div className="mt-2 text-sm text-muted-foreground leading-relaxed">{p.desc}</div>
                <div className="absolute right-4 top-4 font-mono text-xs text-muted-foreground">
                  0{i + 1}
                </div>
              </div>
            );
          })}
        </div>

        <div className="reveal mt-14 text-center">
          <p className="font-display italic text-2xl md:text-4xl text-brand max-w-3xl mx-auto leading-tight">
            “{t.solution.key}”
          </p>
        </div>
      </div>
    </section>
  );
}

function InlineBold({ text }) {
  return text.split(/(\*\*.*?\*\*)/g).map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return (
        <strong key={index} className="font-semibold text-foreground">
          {part.slice(2, -2)}
        </strong>
      );
    }

    return <span key={index}>{part}</span>;
  });
}

function PhoneVideo() {
  return (
    <div className="relative w-[min(100%,19rem)]" data-testid="iphone-mockup">
      <div className="absolute inset-x-8 bottom-2 h-16 rounded-full bg-brand/25 blur-3xl" />

      <div className="relative mx-auto aspect-[590/1198] rounded-[3.4rem] bg-neutral-950 p-[0.62rem] shadow-[0_34px_70px_-24px_rgba(0,0,0,0.72),0_0_0_1px_rgba(255,255,255,0.18)_inset,0_0_0_6px_rgba(18,18,22,1)_inset]">
        <span className="absolute -left-[3px] top-[16%] h-10 w-[3px] rounded-l bg-neutral-700" />
        <span className="absolute -left-[3px] top-[24%] h-16 w-[3px] rounded-l bg-neutral-700" />
        <span className="absolute -left-[3px] top-[33%] h-16 w-[3px] rounded-l bg-neutral-700" />
        <span className="absolute -right-[3px] top-[26%] h-20 w-[3px] rounded-r bg-neutral-700" />

        <div className="relative h-full overflow-hidden rounded-[2.78rem] bg-black ring-1 ring-white/10">
          <video
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
            poster="/innospeq-poster.jpg"
            className="h-full w-full object-cover"
            data-testid="solution-video"
          >
            <source src="/innospeq-preview.webm" type="video/webm" />
            <source src="/innospeq-preview.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  );
}
